(ns app.front.user
  (:require [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::toggle-config-flag
  (fn [{:keys [db]} [_ config-flag]]
    {:db           (update-in db [:session/user :user/config-flags] #(if (contains? % config-flag)
                                                                       (disj % config-flag)
                                                                       (conj (set %) config-flag)))
     :comm/command {:command :user/set-config-flag
                    :data    {:config-flag config-flag
                              :enabled?    (-> db :session/user :user/config-flags config-flag not)}}}))


(rf/reg-event-fx
  ::set-config-flag
  (fn [{:keys [db]} [_ config-flag enabled?]]
    {:db           (update-in db [:session/user :user/config-flags] #(if enabled?
                                                                       (conj (set %) config-flag)
                                                                       (disj % config-flag)))
     :comm/command {:command :user/set-config-flag
                    :data    {:config-flag config-flag
                              :enabled?    enabled?}}}))
